import { render } from "./LiveNow.vue?vue&type=template&id=fccc8c3a"
import script from "./LiveNow.vue?vue&type=script&lang=js"
export * from "./LiveNow.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__